var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget_panel"},[(_vm.experienceType === 'viewer' && _vm.dataObj && _vm.show)?_c('lightViewer',{attrs:{"obj":_vm.dataObj},on:{"onClose":_vm.closeModal}}):(_vm.experienceType === 'spotlight' && _vm.dataObj && _vm.show)?_c('spotlightLight',{attrs:{"obj":_vm.dataObj},on:{"onClose":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }